import {SidebarConfigCallToAction} from '@github-ui/code-view-sidebar/components/SidebarConfigCallToAction'
import {isCombinedSidebarPayloadEnabled} from '@github-ui/code-view-sidebar/is-enabled'
import type {SidebarConfigCallToActionResponse} from '@github-ui/code-view-sidebar/types'
import {
  combinedSidebarPayloadQueryKey,
  useCombinedSidebarPayload,
} from '@github-ui/code-view-sidebar/use-combined-sidebar-payload'
import {useQueryClient, useSuspenseQuery} from '@github-ui/react-query'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

interface SidebarCTAProps {
  ownerLogin: string
  repoName: string
}

export function SidebarCTA(props: SidebarCTAProps) {
  return isCombinedSidebarPayloadEnabled() ? <SidebarCTACombined {...props} /> : <SidebarCTAIndividual {...props} />
}

function SidebarCTACombined({ownerLogin, repoName}: SidebarCTAProps) {
  const {configCallToAction} = useCombinedSidebarPayload(ownerLogin, repoName)
  const queryClient = useQueryClient()

  if (!configCallToAction) return null

  return (
    <SidebarConfigCallToAction
      {...configCallToAction}
      onOptIn={() => {
        queryClient.invalidateQueries({queryKey: combinedSidebarPayloadQueryKey(ownerLogin, repoName)})
      }}
    />
  )
}

function SidebarCTAIndividual({ownerLogin, repoName}: SidebarCTAProps) {
  const queryKey = ['code-view-sidebar', 'cta', {ownerLogin, repoName}]
  const queryClient = useQueryClient()

  const {data} = useSuspenseQuery({
    queryKey,
    queryFn: async () => {
      const r = await verifiedFetchJSON(`/${ownerLogin}/${repoName}/_sidebar/cta`)
      if (!r.ok) throw new Error(`Sidebar CTA fetch failed (${r.status})`)
      return (await r.json()) as SidebarConfigCallToActionResponse
    },
  })

  if (!data) return null

  return (
    <SidebarConfigCallToAction
      {...data}
      onOptIn={() => {
        queryClient.invalidateQueries({queryKey})
      }}
    />
  )
}
